"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.impossibleHouseholdMemberSchema = exports.impossibleHouseholdMemberBirthdayRangeSchema = exports.impossibleHouseholdMemberBirthdayStringSchema = exports.MAX_HOUSEHOLD_MEMBER_AGE_IN_YEARS = exports.MIN_HOUSEHOLD_MEMBER_AGE_IN_YEARS = void 0;
const zod_1 = require("zod");
const constants_1 = require("../constants");
const GenderTypes_1 = require("../enums/GenderTypes");
const RelationshipTypes_1 = require("../enums/RelationshipTypes");
const dates_1 = require("../dates");
const BirthdayRange_1 = require("./BirthdayRange");
const Name_1 = require("./Name");
exports.MIN_HOUSEHOLD_MEMBER_AGE_IN_YEARS = 18;
exports.MAX_HOUSEHOLD_MEMBER_AGE_IN_YEARS = 122;
exports.impossibleHouseholdMemberBirthdayStringSchema = (0, dates_1.dateInYearsRangeStringSchemaFactory)(exports.MIN_HOUSEHOLD_MEMBER_AGE_IN_YEARS, exports.MAX_HOUSEHOLD_MEMBER_AGE_IN_YEARS);
exports.impossibleHouseholdMemberBirthdayRangeSchema = BirthdayRange_1.impossibleBirthdayRangeSchema
    .extend({
    start: zod_1.z.optional(exports.impossibleHouseholdMemberBirthdayStringSchema),
    end: zod_1.z.optional(exports.impossibleHouseholdMemberBirthdayStringSchema),
})
    .strict();
exports.impossibleHouseholdMemberSchema = zod_1.z.object({
    name: Name_1.impossibleNameSchema,
    relationship: zod_1.z.nullable(zod_1.z.nativeEnum(RelationshipTypes_1.RelationshipTypes)),
    birthday: zod_1.z.nullable(exports.impossibleHouseholdMemberBirthdayStringSchema),
    birthdayRange: zod_1.z.nullable(exports.impossibleHouseholdMemberBirthdayRangeSchema),
    gender: zod_1.z.nullable(zod_1.z.nativeEnum(GenderTypes_1.GenderTypes)),
    occupation: zod_1.z.nullable(constants_1.defaultOccupationString),
}).strict();
